<div id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/01_Bosco-Parco-Serre.jpg">
    <div class="content">
        <h1>Calabria</h1>
        <h3>Parchi e Riserve</h3>
    </div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a class="active">Parchi e riserve</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Ecosistemi naturali, patrimonio di biodiversità prezioso e inestimabile che popola valli, boschi
            e percorsi fluviali, dalla montagna al mare: la Calabria preserva ben 13 Aree naturali tra Parchi e Riserve
            marine:
            i Parchi nazionali del Pollino, della Sila e dell’Aspromonte; il Parco Regionale delle Serre e le Riserve
            Naturali di Valli Cupe e
            del Lago di Tarsia - Foce del fiume Crati; l’Area Marina Protetta di Capo Rizzuto e sei Parchi Marini (Costa
            dei Gelsomini,
            Baia di Soverato, Scogli di Isca, Riviera dei Cedri, Secca di Amendolara, Fondali Capocozzo, S. Irene, Vibo
            Marina, Tropea).
            <br>
            <br>
            Aree protette a cui si aggiunge l’Area MaB del Parco della Sila che rappresenta la X Riserva della Biosfera
            italiana nella
            rete mondiale dei siti di eccellenza UNESCO e ricopre una superficie di 355 mila ettari nel cuore della
            Calabria.
        </p>
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Parco Nazionale<br>del Pollino</h1>
                        <a (click)="goTo()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Parco Nazionale<br>della Sila</h1>
                        <a (click)="goToSila()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Parco Naturale<br>delle Serre</h1>
                        <a (click)="goToSerre()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-12 col-xl-3 four" id="four">
            <div class="card four">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Parco Nazionale<br>dell’Aspromonte</h1>
                        <a (click)="goToAspromonte()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 five" id="five">
            <div class="card five">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Riserva Naturale<br>Valli Cupe</h1>
                        <a (click)="goToValli()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 six" id="six">
            <div class="card six">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Riserve Naturali<br>Lago Tarsia -<br>Foce Crati</h1>
                        <a (click)="goToTarsia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="page-banner">
    <div id="banner">
        <div class="banner">
            <div class="content-banner">
                <h1>Parchi e Aree<br>Marine protette</h1>
                <a (click)="goToAreeMarine()">Scopri</a>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>
<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte,
                    esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>